export const mergePackDistributions = (packs, distributions) => {
  return packs.map((item) => {
    const dist = distributions.find((x) => x.id.toString() === item.dist_id);
    return Object.assign({}, item, {
      distributionImageUrl: dist?.images?.[0]?.url,
      numberOfPackSlots: dist?.numberOfPackSlots,
      tier: dist?.tier || '',
      title: dist?.title,
    });
  });
};
